const appConfig = {
  apiBaseUrl: "https://api.jewelleryhiring.com/",
  apiPrefix: "/api",
  authenticatedEntryPath: "app/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  enableMock: false,
};

export default appConfig;
